enum ActionType {
    REQUEST_QM_MESSAGES = '[CORE/QM_MESSAGES] REQUEST QM_MESSAGES',
    RECEIVE_QM_MESSAGES = '[CORE/QM_MESSAGES] RECEIVE QM_MESSAGES',
    DELETE_QM_MESSAGES = '[CORE/QM_MESSAGES] DELETE QM_MESSAGE',
}

export default ActionType
